import { BASE_URL } from "constants/api";


export const getFullPath = (path: string) => {
    return BASE_URL + path;
}